import { BusinessIncome } from "@/hooks/useBusinessIncome";

export const BUSINESS_INCOME_TYPES: BusinessIncome["income_type"][] = [
  "Hospedaje",
  "Limpieza",
  "Lavandería",
  "Comisión",
  "Administración",
  "Extras",
  "Extraordinario",
] as const;

export const BUSINESS_PAYMENT_TYPES: BusinessIncome["payment_type"][] = [
  "Transferencia",
  "Efectivo",
  "Deducción",
] as const;
